<script setup>
    // Store
    import { useHomeStore } from '@/stores/home/homeStore';
    import { useNewsDetailStore } from '@/stores/modal/newsDetailStore';
    import { useLanguageStore } from '@/stores/common/languageStore';
    import { useCommonStore } from '@/stores/common/commonStore';
    import { useReserveStore } from '@/stores/reserve/reserveStore';

    // Utis
    import utils from '@/commonProject/helpers/utils';

    // Vue
    import { defineEmits, defineExpose, inject, computed } from 'vue';
    import { ref } from 'vue';
    import { useRouter } from 'vue-router';
    import PaginationNews from '@/components/PaginationComponentNews.vue';

    // ----------------------------
    // お知らせ詳細
    // ----------------------------
    const newsDetailStore = useNewsDetailStore();
    const newsModal = ref({
        newsModalDetail: 'block',
        newsModalComplete: '',
    });
    const router = useRouter();
    const consultationWebPageFlag = ref(false);
    const homeStore = useHomeStore();

    const reserveStore = useReserveStore();

    const languageStore = useLanguageStore();
    const commonStore = useCommonStore();

    const keepNoticeHistPk = ref('');
    //let keepApiUrl = '';
    const API_URL = ref('');

    const DELIMITER = ':::::';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    // 本文に含まれるhttp、httpsをリンクに変換する。
    // 既存aタグはそのまま維持し、aタグ外のURLのみ自動リンク化する（2重リンク防止）。
    const noticeMessageHtml = computed(() => {
        const text = newsDetailStore.NoticeMessage || '';
        const withLinks = text.replace(/(<a\b[^>]*>[\s\S]*?<\/a>)|(https?:\/\/[^\s<>"]+)/gi, (match, anchor, url) => {
            if (anchor) return anchor;
            return `<a href="${url}">${url}</a>`;
        });
        return withLinks.replace(/\r\n|\n|\r/g, '<br>');
    });

    /**
     * ページ操作
     * @param newPage
     */
    // ページングパーツ
    const currentPage = ref(1);
    const totalPages = ref(0);
    async function handlePageChange(newPage) {
        const page = newPage - 1;
        currentPage.value = newPage;
        await getNewsDetail(homeStore.List[page].NoticeType, homeStore.List[page].NoticeBulletinPk, homeStore.List[page].NoticeHistPk, homeStore.List[page].NoticeReaded);

        // モーダルのHTML要素を取得する。
        const elm1 = document.querySelector('#modalInformation .modalContents');

        // モーダルの縦スクロールを先頭に戻す。
        elm1.scrollTop = 0;
    }
    const pagination = ref();
    /**
     * ページングの初期処理を実行する。
     * 取得したAPIのデータ数を引き渡す。
     */
    function handleOnloadPagination(RowResult) {
        pagination.value.onload(RowResult);
    }

    /**
     * お知らせ詳細取得処理
     * @param requestdForm
     */
    async function getNewsDetail(noticeType, noticeBulletinPk, noticeHistPk, noticeReaded) {
        // Storeを初期化する。
        newsDetailStore.NoticeDt = '';
        newsDetailStore.NoticeSubject = '';
        newsDetailStore.NoticeMessage = '';

        newsModal.value.newsModalDetail = 'block';
        newsModal.value.newsModalComplete = '';
        consultationWebPageFlag.value = false;

        let queryParam = {
            Lang: languageStore.getLanguageValue,
            NoticeType: noticeType,
        };

        if (!utils.isNullEmpty(noticeBulletinPk)) {
            queryParam['NoticeBulletinPk'] = noticeBulletinPk;
        }

        if (!utils.isNullEmpty(noticeHistPk)) {
            queryParam['NoticeHistPk'] = noticeHistPk;
            keepNoticeHistPk.value = noticeHistPk;
        }

        //keepApiUrl = URL;
        //API_URL.value = URL

        const response = await newsDetailStore.getNewsDetailAction(API_URL.value, queryParam);

        if (response.success) {
            if (!noticeReaded) {
                let requestBody2 = {
                    NoticeType: noticeType,
                };

                if (!utils.isNullEmpty(noticeBulletinPk)) {
                    requestBody2['NoticeBulletinPk'] = noticeBulletinPk;
                }

                if (!utils.isNullEmpty(noticeHistPk)) {
                    requestBody2['NoticeHistPk'] = noticeHistPk;
                }

                const response2 = await newsDetailStore.updateNewsDetailReadedAction(API_URL.value, requestBody2);

                if (!response2.success) {
                    messageDialog('error', response2.errorMessage);
                    if (response2.redirect) {
                        location.href = response2.redirectUrl;
                    }
                    return;
                }
            }

            // ニュースのデータ内にあるHTML要素データから、特定のボタンパーツを抽出する。
            // ニュースコンテンツ本体
            const target = document.querySelector('div[class="informationBody"]');
            // ニュースコンテンツ本体の中に存在する要素を検索する。
            if (!utils.isNull(target)) {
                // ボタン要素を抽出する。
                const btn = target.querySelectorAll('button');
                // ボタン要素が存在するか判定する。
                if (!utils.isNull(btn)) {
                    // 各ボタン要素にJavascriptのクリックイベントを付与。実行する関数も設定。
                    btn.forEach((elm) => {
                        elm.addEventListener('click', jumpToPage);
                    });
                }
            }

            if (!utils.isNullEmptyArray(homeStore.List)) {
                // お知らせモーダルのページング制御のために、最大ページ数を取得する。
                handleOnloadPagination(homeStore.List.length);
            }
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }

    /**
     * 現況把握のボタンクリックのイベント。
     */
    async function jumpToPage() {
        // Storeを初期化する。
        commonStore.form = '';

        // ボタンのJavascript要素。
        const elm = this;

        // 遷移先をボタンから抽出する。
        const jumpPage = elm.dataset.jumpPage;

        // ボタン上の文言を抽出する。
        const textContent = elm.textContent;

        // ボタンクリックをトリガーにした、遷移先の座標を制御する。
        switch (jumpPage) {
            case 'contact':
                // 連絡モーダルを開く。
                openContactModalFromNewDetailModal();
                break;
            case 'survey':
                {
                    // ニュースボタンにアンケートを表示するボタンが存在する場合。

                    // クリックしたボタンのHTML要素の情報を取得する。
                    const openModal = elm.dataset.param;

                    switch (true) {
                        case openModal.indexOf('ReservationPk=') !== -1:
                            {
                                // 予約詳細画面のアンケート画面を表示する。

                                // クリックしたニュースのボタンから予約PKを取得する。
                                const jumpToReservationPk = openModal.split('ReservationPk=')[1];

                                // Storeを経由して、画面遷移元を指定し、アンケートIDを予約画面に引き渡す。
                                commonStore.from = 'NewsDetail';

                                reserveStore.reservationPk = jumpToReservationPk;
                                // ハンバーガーメニューからの遷移時、遷移前と遷移先が同一画面の場合リロードして表示する
                                if (window.location.pathname.includes("/reserve/detail"))
                                {
                                    router.go({ path: '/reserve/detail', force: true });
                                } else {
                                    router.push({ name: 'reservedetail' });
                                }
                                
                                
                            }
                            break;
                        case openModal.indexOf('WebCngPk=') !== -1:
                            {
                                // Web相談画面のアンケート画面を表示する。

                                // クリックしたニュースのボタンからWeb相談PKを取得する。
                                const jumpToWebCngPk = openModal.split('WebCngPk=')[1];

                                // Storeを経由して、画面遷移元を指定し、アンケートIDを予約画面に引き渡す。
                                commonStore.from = 'NewsDetail' + DELIMITER + jumpToWebCngPk;

                                // Web相談
                                // ハンバーガーメニューからの遷移時、遷移前と遷移先が同一画面の場合リロードして表示する
                                if (window.location.pathname.includes("web"))
                                {
                                    router.go({ path: '/consultation/web/list', force: true });
                                } else {
                                    router.push({ name: 'consultationWebList' });
                                }
                            }
                            break;
                        case openModal.indexOf('QuestionaryPk=') !== -1:
                            {
                                // 上記のいずれも該当しないので、ホーム画面にアンケート画面を表示する。

                                // クリックしたニュースのボタンからアンケートPKを取得する。
                                const jumpToQuestionaryPk = openModal.split('QuestionaryPk=')[1];

                                // アンケート画面の表示関数を実行する。
                                await openSuerveyApllyModalFromNewsDetailModal(jumpToQuestionaryPk);
                            }
                            break;
                        default:
                            // 何もしない。
                            break;
                    }
                }
                break;
            case 'reservePlanningConsultation':
                {
                    // 相談内容から利用方法等選択
                    await getUserStatusReserveFunction('1');
                }
                break;
            case 'reservePlanningProgram':
                {
                    // プログラムからサービス選択
                    await getUserStatusReserveFunction('2');
                }
                break;
            case 'reservePlanningPersonal':
                {
                    // 割り当てからサービス選択
                    await getUserStatusReserveFunction('3');
                }
                break;
            case 'consultationWebList':
                {
                    // Storeを経由して、画面遷移元を指定し、新規でWeb相談モーダルを開く。
                    commonStore.from = 'NewsDetail';

                    // Web相談
                    // ハンバーガーメニューからの遷移時、遷移前と遷移先が同一画面の場合リロードして表示する
                    if (window.location.pathname.includes("web"))
                    {
                        router.go({ path: '/consultation/web/list', force: true });
                    } else {
                        router.push({ name: 'consultationWebList' });
                    }
                }
                break;
            case 'CurrentStatus1':
            case 'currentStatus1':
                {
                    // 現況把握回答の次の回答がクリックされた場合の処理。
                    // ・カウンセラーに相談したい
                    const newsResponse = await updateNewsResponse('4', textContent);
                    if (newsResponse) {
                        newsModal.value.newsModalDetail = '';
                        newsModal.value.newsModalComplete = 'block';
                        consultationWebPageFlag.value = true;
                    }
                }

                break;
            case 'currentStatus2':
                {
                    // 現況把握回答の次の回答がクリックされた場合の処理。
                    // ・専門機関（医療機関やその他相談機関）を受診中または受診予定
                    const newsResponse = await updateNewsResponse('3', textContent);
                    if (newsResponse) {
                        newsModal.value.newsModalDetail = '';
                        newsModal.value.newsModalComplete = 'block';
                        consultationWebPageFlag.value = false;
                    }
                }
                break;
            case 'currentStatus3':
                {
                    // 現況把握回答の次の回答がクリックされた場合の処理。
                    // ・問題を抱えていて対応が難しい
                    const newsResponse = await updateNewsResponse('5', textContent);
                    if (newsResponse) {
                        newsModal.value.newsModalDetail = '';
                        newsModal.value.newsModalComplete = 'block';
                        consultationWebPageFlag.value = true;
                    }
                }
                break;
            case 'currentStatus4':
                {
                    // 現況把握回答の次の回答がクリックされた場合の処理。
                    // ・周囲からの援助や相談をすることで対処できている
                    const newsResponse = await updateNewsResponse('2', textContent);
                    if (newsResponse) {
                        newsModal.value.newsModalDetail = '';
                        newsModal.value.newsModalComplete = 'block';
                        consultationWebPageFlag.value = false;
                    }
                }
                break;
            case 'currentStatus5':
                {
                    // 現況把握回答の次の回答がクリックされた場合の処理。
                    // ・自分で問題なく対処できている
                    const newsResponse = await updateNewsResponse('1', textContent);
                    if (newsResponse) {
                        newsModal.value.newsModalDetail = '';
                        newsModal.value.newsModalComplete = 'block';
                        consultationWebPageFlag.value = false;
                    }
                }
                break;
            default:
                // 何もしない。
                break;
        }
    }

    /**
     * ユーザー状態確認（予約）APIをコールする。
     * 現在登録されている件数以上を登録できない場合はエラーを返却して、予約画面に進ませない。
     * @param mode
     */
    async function getUserStatusReserveFunction(mode) {
        // ユーザー状態確認（予約）APIのクエリパラメーターを生成する。
        const queryParam = {
            Mode: mode,
        };

        // ユーザー状態確認（予約）APIをコールする。
        const response = await homeStore.getUserStatusReserveAction(API_URL.value, queryParam);

        if (response.success) {
            switch (mode) {
                case '1':
                    // 相談内容を選んで予約
                    // ハンバーガーメニューからの遷移時、遷移前と遷移先が同一画面の場合リロードして表示する
                    if (window.location.pathname.includes("/reserve/planning/consultation"))
                    {
                        router.go({ path: '/reserve/planning/consultation', force: true });
                    } else {
                        router.push({ name: 'reserveplanningconsultation' });
                    }
                    break;
                case '2':
                    // プログラムを選んで予約
                    // ハンバーガーメニューからの遷移時、遷移前と遷移先が同一画面の場合リロードして表示する
                    if (window.location.pathname.includes("/reserve/planning/program"))
                    {
                        router.go({ path: '/reserve/planning/program', force: true });
                    } else {
                        router.push({ name: 'reserveplanningprogram' });
                    }
                    break;
                case '3':
                    // 割当てられたプログラムを予約
                    // ハンバーガーメニューからの遷移時、遷移前と遷移先が同一画面の場合リロードして表示する
                    if (window.location.pathname.includes("/reserve/planning/personal"))
                    {
                        router.go({ path: '/reserve/planning/personal', force: true });
                    } else {
                        router.push({ name: 'reserveplanningpersonal' });
                    }
                    break;
                default:
                    // 何もしない。
                    break;
            }
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    }

    /**
     * お知らせ回答APIをコールする。
     * @param noticeAnsCd
     * @param noticeAnsDetail
     */
    async function updateNewsResponse(noticeAnsCd, noticeAnsDetail) {
        // お知らせ回答APIのリクエストボディを生成する。
        const requestBody = {
            NoticeHistPk: keepNoticeHistPk.value,
            NoticeAnsCd: noticeAnsCd,
            NoticeAnsDetail: noticeAnsDetail,
        };
        // お知らせ回答APIをコールする。
        const response = await newsDetailStore.setNewsSelectedAnswerAction(API_URL.value, requestBody);
        if (!response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return false;
        }
        return true;
    }

    function goToConsultationWebPage() {
        commonStore.from = 'NewsDetail2' + DELIMITER + keepNoticeHistPk.value;
        // ハンバーガーメニューからの遷移時、遷移前と遷移先が同一画面の場合リロードして表示する
         if (window.location.pathname.includes("/consultation/web/list"))
        {
            router.go({ path: '/consultation/web/list', force: true });
        } else {
            router.push({ name: 'consultationWebList' });
        }
    }

    // ----------------------------
    // 親側実装必須処理
    // ----------------------------
    const emit = defineEmits(['newsDetailModal:close', 'newsDetailModal:openContactModalFromNewDetailModal', 'newsDetailModal:openSuerveyApllyModalFromNewsDetailModal']);

    function close() {
        document.removeEventListener('click', function () {}, true);
        // 親画面のモーダル非表示処理を呼び出す
        emit('newsDetailModal:close');

        document.body.classList.remove('modal-open'); //スクロール再開

        // モーダルのHTML要素を取得する。
        const elm1 = document.querySelector('#modalInformation .modalContents');

        // モーダルの縦スクロールを先頭に戻す。
        elm1.scrollTop = 0;
    }

    function openContactModalFromNewDetailModal() {
        document.removeEventListener('click', function () {}, true);
        // 親画面のモーダル非表示処理を呼び出す
        emit('newsDetailModal:openContactModalFromNewDetailModal');

        document.body.classList.remove('modal-open'); //スクロール再開
    }

    /**
     * 予約画面やWeb相談画面では無く、いずれにも属さないアンケートPKを取得し、ホーム画面にアンケート画面を表示する。
     */
    async function openSuerveyApllyModalFromNewsDetailModal(questionaryPk) {
        // 親画面のモーダル非表示処理を呼び出す
        emit('newsDetailModal:openSuerveyApllyModalFromNewsDetailModal', questionaryPk);
    }

    // ----------------------------
    // 親画面から利用可能関数
    // ----------------------------
    function newsDetailSet(URL, noticeType, noticeBulletinPk, noticeHistPk, noticeReaded, index) {
        // APIのコール先を設定する。
        API_URL.value = URL;

        // 1ページ目に戻す。
        currentPage.value = index + 1;

        // 全ページ数を取得する。
        totalPages.value = homeStore.List.length;

        // 初期化
        keepNoticeHistPk.value = '';

        // お知らせ詳細取得APIをコールする。
        getNewsDetail(noticeType, noticeBulletinPk, noticeHistPk, noticeReaded);
    }

    defineExpose({
        newsDetailSet,
    });
</script>
<style></style>
<template>
    <article id="modalInformation" class="modal" :style="{ display: newsModal.newsModalDetail }">
        <!--お知らせモーダル-->
        <h3>{{ $t('newsDetail.parts.modalTitle1') }}</h3>
        <section class="modalContents">
            <section class="information">
                <ul class="informationTitle">
                    <li>
                        <span>{{ newsDetailStore.NoticeDt }}</span>
                    </li>
                    <li>
                        <span>{{ newsDetailStore.NoticeSubject }}</span>
                    </li>
                </ul>
                <div class="informationBody" v-html="noticeMessageHtml" />
            </section>
            <PaginationNews ref="pagination" :currentPage="currentPage" :totalPages="totalPages" @pageChanged="handlePageChange" />
        </section>
        <section class="modalFooter">
            <ul class="btnArea center">
                <li>
                    <!--閉じる-->
                    <button type="button" class="btnNormal" @click="close">{{ $t('common.parts.close') }}</button>
                </li>
            </ul>
        </section>
    </article>
    <article id="modalKaitouTokurokuComplete" class="modal small" :style="{ display: newsModal.newsModalComplete }">
        <!--現況回答モーダル-->
        <p class="textCenter">{{ $t('hearingComplete.parts.modalTitle1') }}</p>
        <template v-if="consultationWebPageFlag">
            <!--カウンセリングの相談への動線-->
            <section class="modalContents" style="width: 400px; height: 160px; margin-bottom: 0">
                <section class="form">
                    <div class="formBox">
                        <p class="textCenter">{{ $t('hearingComplete.parts.modalInformation1') }}</p>
                        <ul class="btnArea center">
                            <li>
                                <button type="button" class="btnPrimary" @click="goToConsultationWebPage">{{ $t('hearingComplete.parts.modalButton1') }}</button>
                            </li>
                        </ul>
                    </div>
                </section>
            </section>
        </template>
        <section class="dialogFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="close">{{ $t('common.parts.close') }}</button>
                </li>
            </ul>
        </section>
    </article>
</template>
